import { twMerge } from 'tailwind-merge';
import { Box, InputLabel, Typography } from '@mui/material';

import { useCourseContext } from 'context';
import { FieldArrayFormField } from 'types';

import { DynamicFormFields } from '.';

export const FieldArrayField = ({ label, options }: FieldArrayFormField) => {
  const { language } = useCourseContext();
  const isHorizontal = options?.layout === 'horizontal';
  return (
    <Box>
      {label && <InputLabel>{label}</InputLabel>}
      {options && (
        <>
          <Box
            className={twMerge(
              'flex',
              !isHorizontal && 'flex-col',
              isHorizontal && 'flex-wrap'
            )}
          >
            <DynamicFormFields
              hideLabels
              fields={options.fields}
              container={(field, node, index) => {
                let label = field.label;
                if ('translations' in field) {
                  const translation = field.translations![language];
                  if (translation && 'label' in translation) {
                    label = translation.label;
                  }
                }
                return (
                  <Box
                    key={field.id}
                    className={twMerge(
                      'flex w-full flex-1 gap-2',
                      !isHorizontal && 'flex-col',
                      isHorizontal && 'max-w-1/2 basis-1/2',
                      index > (isHorizontal ? 1 : 0) && 'mt-2'
                    )}
                  >
                    {!isHorizontal && (
                      <Typography className="w-full">{label}</Typography>
                    )}
                    <Box
                      className={
                        isHorizontal ? 'flex-1' : 'w-full [&>div]:w-full'
                      }
                    >
                      {node}
                    </Box>
                    {isHorizontal && (
                      <Box className="flex-1">
                        <Typography className="mt-3">{label}</Typography>
                      </Box>
                    )}
                  </Box>
                );
              }}
            />
          </Box>
        </>
      )}
    </Box>
  );
};
